module.exports = __webpack_public_path__ + "ipetbooking/admin/img/users-class.ef48c3c8.svg";